function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "aaa",
  x1: 20.12,
  y1: 32.48,
  x2: 20.12,
  y2: 7.96,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#31198f"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#40f"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.42,39.12h-.9A11.67,11.67,0,0,1,5.65,39,5.86,5.86,0,0,1,4,38.4a4.93,4.93,0,0,1-1.39-1,5.12,5.12,0,0,1-1-1.4A5.69,5.69,0,0,1,1,34.34a11.7,11.7,0,0,1-.16-1.87V7.55A11.7,11.7,0,0,1,1,5.68,5.51,5.51,0,0,1,1.58,4a5.12,5.12,0,0,1,1-1.4A5.58,5.58,0,0,1,4,1.6a5.69,5.69,0,0,1,1.66-.55A11.83,11.83,0,0,1,7.52.89H132.06a11.58,11.58,0,0,1,1.86.16,5.85,5.85,0,0,1,1.67.55,5.34,5.34,0,0,1,1.4,1,5.64,5.64,0,0,1,1.52,3.05,11.85,11.85,0,0,1,.18,1.88V32.47a12.72,12.72,0,0,1-.17,1.85A5.89,5.89,0,0,1,138,36a5.71,5.71,0,0,1-1,1.39,5.12,5.12,0,0,1-1.4,1,5.85,5.85,0,0,1-1.67.55,11.7,11.7,0,0,1-1.87.16H8.42Z",
  transform: "translate(0)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "140.62px",
    height: "41px",
    viewBox: "0 0 140.62 41"
  }, props), _ref, React.createElement("path", {
    d: "M130.07,0H7.5a13.39,13.39,0,0,0-2,.18A6.74,6.74,0,0,0,3.6.81,6.11,6.11,0,0,0,2,2,6.07,6.07,0,0,0,.8,3.62a6.74,6.74,0,0,0-.63,1.9,12.18,12.18,0,0,0-.17,2v25a12.18,12.18,0,0,0,.17,2A6.8,6.8,0,0,0,.8,36.43,5.83,5.83,0,0,0,2,38,6.07,6.07,0,0,0,3.6,39.18a6.74,6.74,0,0,0,1.9.63,13.39,13.39,0,0,0,2,.18H132.08a13.39,13.39,0,0,0,2-.18,7.14,7.14,0,0,0,1.91-.63A6,6,0,0,0,137.6,38a6.28,6.28,0,0,0,1.19-1.61,6.76,6.76,0,0,0,.61-1.91,12.2,12.2,0,0,0,.19-2v-25a12.2,12.2,0,0,0-.19-2,6.7,6.7,0,0,0-.61-1.9A6.13,6.13,0,0,0,137.6,2,6.07,6.07,0,0,0,136,.82a7.07,7.07,0,0,0-1.9-.63,13.39,13.39,0,0,0-2-.18h-2Z",
    transform: "translate(0)",
    style: {
      "fill": "#a6a6a6"
    }
  }), _ref2, React.createElement("path", {
    d: "M42.1,14.75H38.39V8.8h.92v5.1H42.1Z",
    transform: "translate(0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M43.19,8.93a.55.55,0,0,1,.55-.55h0a.55.55,0,1,1,.15,1.09h-.15a.56.56,0,0,1-.57-.53Zm.13,1.33h.88v4.49h-.88Z",
    transform: "translate(0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M47.28,10.17c1,0,1.67.47,1.76,1.26h-.85c-.08-.33-.4-.54-.91-.54s-.87.24-.87.59.23.44.72.55l.74.17c.86.2,1.26.57,1.26,1.23,0,.84-.79,1.41-1.86,1.41s-1.77-.48-1.85-1.28h.89c.11.35.44.56,1,.56s.94-.25.94-.61-.21-.44-.66-.54l-.78-.19c-.86-.2-1.25-.58-1.25-1.25A1.59,1.59,0,0,1,47.28,10.17Z",
    transform: "translate(0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M51.5,9.14v1.14h1V11h-1v2.31c0,.47.19.67.63.67h.34v.74a1.93,1.93,0,0,1-.48,0c-1,0-1.38-.35-1.38-1.22V11H49.9v-.75h.71V9.14Z",
    transform: "translate(0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M57.4,13.54a1.82,1.82,0,0,1-2,1.3,2,2,0,0,1-2.09-1.9,2.94,2.94,0,0,1,0-.42,2.08,2.08,0,0,1,1.77-2.33h.3c1.25,0,2,.86,2,2.27v.31h-3.1v.05a1.19,1.19,0,0,0,1.09,1.28h.11a1.09,1.09,0,0,0,1.07-.54Zm-3.12-1.45h2.27a1.09,1.09,0,0,0-1-1.16h-.11a1.14,1.14,0,0,0-1.16,1.12v0Z",
    transform: "translate(0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M58.65,10.26h.86V11h.06a1.36,1.36,0,0,1,1.35-.8,1.46,1.46,0,0,1,1.56,1.35,1.71,1.71,0,0,1,0,.32v2.91h-.9V12.07c0-.73-.31-1.09-1-1.09a1,1,0,0,0-1.08.91h0v2.85h-.89Z",
    transform: "translate(0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M66.07,12.5a2.13,2.13,0,0,1,4.24-.45v0a2.81,2.81,0,0,1,0,.41,2.13,2.13,0,0,1-4.24.45v0A2.81,2.81,0,0,1,66.07,12.5Zm3.33,0c0-1-.44-1.54-1.21-1.54S67,11.53,67,12.5s.43,1.55,1.2,1.55S69.4,13.48,69.4,12.5Z",
    transform: "translate(0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M71.51,10.26h.86V11h.06a1.36,1.36,0,0,1,1.34-.8,1.46,1.46,0,0,1,1.57,1.34,1.82,1.82,0,0,1,0,.33v2.91h-.89V12.07c0-.73-.31-1.09-1-1.09a1,1,0,0,0-1.08.91h0v2.85h-.89Z",
    transform: "translate(0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("rect", {
    x: 7.54,
    y: 7.4,
    width: 25.15,
    height: 25.15,
    rx: 6,
    style: {
      "fill": "url(#aaa)"
    }
  }), React.createElement("path", {
    d: "M23.5,21.17a1.15,1.15,0,0,1-.6.16,3.63,3.63,0,0,1-1.13-.16h-.21c-.07,0-.09,0-.09.13v.24a.22.22,0,0,0,.18.25A3.15,3.15,0,0,0,22.9,22a1.82,1.82,0,0,0,1.15-.35,1.07,1.07,0,0,0,.44-.92,1.05,1.05,0,0,0-.21-.75,1.74,1.74,0,0,0-.69-.44L23,19.35a1.18,1.18,0,0,1-.5-.28.4.4,0,0,1-.14-.34c0-.35.25-.53.78-.53a2.89,2.89,0,0,1,.88.13l.18.05c.07,0,.12-.05.12-.14V18a.3.3,0,0,0-.05-.16c0-.05-.07-.07-.14-.09a3.11,3.11,0,0,0-1-.19A1.78,1.78,0,0,0,22,17.9a1,1,0,0,0-.41.85,1.21,1.21,0,0,0,.9,1.15l.69.26a1.38,1.38,0,0,1,.46.25.41.41,0,0,1,.12.32.51.51,0,0,1-.21.44ZM26,16.12a.53.53,0,0,0-.4-.14.45.45,0,0,0-.36.14.44.44,0,0,0-.14.34.43.43,0,0,0,.14.35.45.45,0,0,0,.36.14.47.47,0,0,0,.37-.14.43.43,0,0,0,.14-.35A.47.47,0,0,0,26,16.12Zm-.14,1.57h-.49c-.11,0-.16,0-.16.16v3.83c0,.12,0,.16.16.16h.49c.11,0,.16,0,.16-.16V17.85a.15.15,0,0,0-.14-.16Zm2.17.92a1.28,1.28,0,0,1,1-.35,2.18,2.18,0,0,1,.67.1.33.33,0,0,0,.14,0c.07,0,.11-.05.11-.16V18a.22.22,0,0,0,0-.16l-.12-.1a3.74,3.74,0,0,0-.88-.13,2,2,0,0,0-1.5.57,2.37,2.37,0,0,0-.53,1.62,2.24,2.24,0,0,0,.51,1.59,1.9,1.9,0,0,0,1.48.55,2.23,2.23,0,0,0,.92-.16c.07,0,.12,0,.14-.09s0-.09,0-.16V21.3c0-.12,0-.16-.11-.16a.24.24,0,0,0-.12,0,2.65,2.65,0,0,1-.74.11,1.27,1.27,0,0,1-1-.34,1.63,1.63,0,0,1-.3-1.09v-.11a1.78,1.78,0,0,1,.3-1.1ZM15.49,21.84H16c.12,0,.17,0,.17-.16V18.8a1.19,1.19,0,0,0-.3-.9,1.14,1.14,0,0,0-.88-.33,2.78,2.78,0,0,0-1.62.58,1,1,0,0,0-1-.58,2.74,2.74,0,0,0-1.53.53v-.25a.14.14,0,0,0-.07-.12.24.24,0,0,0-.12,0h-.45a.14.14,0,0,0-.16.12V21.7c0,.12.05.16.16.16h.49c.11,0,.16,0,.16-.16V18.59a2.32,2.32,0,0,1,1.2-.37.52.52,0,0,1,.48.21,1,1,0,0,1,.16.6v2.65c0,.12.05.16.17.16h.48c.12,0,.16,0,.16-.16V18.59a2.23,2.23,0,0,1,1.2-.37.55.55,0,0,1,.49.21,1,1,0,0,1,.16.6v2.65C15.33,21.8,15.33,21.84,15.49,21.84Zm4.38-4v3.07a2.13,2.13,0,0,1-1.17.39.7.7,0,0,1-.56-.21,1,1,0,0,1-.16-.64v-2.6c0-.12,0-.16-.16-.16h-.48c-.12,0-.17,0-.17.16v2.86a1.3,1.3,0,0,0,.3.92,1.2,1.2,0,0,0,.9.33A2.62,2.62,0,0,0,20,21.4l.05.28a.11.11,0,0,0,.07.12h.48c.12,0,.17-.05.17-.16V17.85c0-.12-.05-.16-.17-.16H20.1c-.14,0-.19.07-.19.16Z",
    transform: "translate(0)",
    style: {
      "fill": "#fff",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M29,27.08c1.2-1,1.52-3.12,1.27-3.44A2.38,2.38,0,0,0,29,23.36,4.07,4.07,0,0,0,26.7,24c-.21.14-.16.32.05.3.71-.09,2.33-.28,2.63.09s-.33,1.89-.6,2.56c-.07.21.09.28.3.14Zm-1-2.17a20.47,20.47,0,0,1-7.76,1.59,20.32,20.32,0,0,1-10.15-2.7.33.33,0,0,0-.14,0c-.16,0-.25.18-.09.34A15,15,0,0,0,20.08,28a14.66,14.66,0,0,0,8.31-2.54c.39-.28.07-.69-.32-.53Z",
    transform: "translate(0)",
    style: {
      "fill": "#fff",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M68.53,30a26,26,0,0,1-10,2,26.39,26.39,0,0,1-13.07-3.43c-.32-.19-.56.15-.29.39A19.4,19.4,0,0,0,58.23,33.9,19,19,0,0,0,69,30.62C69.43,30.27,69,29.75,68.53,30Z",
    transform: "translate(0)",
    style: {
      "fill": "#40f",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M66.7,28.76c-.25.17-.21.44.08.39.92-.12,3-.36,3.37.11s-.41,2.41-.76,3.28c-.1.26.12.36.36.17,1.55-1.32,2-4,1.64-4.38S68.36,27.6,66.7,28.76Z",
    transform: "translate(0)",
    style: {
      "fill": "#40f",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M72.36,25.49a5.64,5.64,0,0,0-2.88-.62l2.62-3.72a1.54,1.54,0,0,0,.39-.72v-1a.29.29,0,0,0-.28-.28H67.13a.27.27,0,0,0-.29.25v0h0v1.13a.29.29,0,0,0,.28.28h2.64l-3,4.34a1.3,1.3,0,0,0-.19.77v1.14c0,.16.19.35.36.26a5.87,5.87,0,0,1,5.35,0c.19.1.37-.09.37-.26V25.93A.51.51,0,0,0,72.36,25.49Z",
    transform: "translate(0)",
    style: {
      "fill": "#40f",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M76.84,19c-2.23,0-3.47,1.91-3.47,4.36s1.23,4.37,3.47,4.37,3.5-1.9,3.5-4.3S79.12,19,76.84,19Zm0,7.12c-1.21,0-1.19-2-1.19-3s.07-2.5,1.2-2.5a1,1,0,0,1,1,.76,7.37,7.37,0,0,1,.23,2.09c0,1,0,2.68-1.24,2.68Z",
    transform: "translate(0)",
    style: {
      "fill": "#40f",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M59.91,22.82a2.62,2.62,0,0,0-1.64,2.51,2.17,2.17,0,0,0,2,2.38,1.93,1.93,0,0,0,.34,0,3.06,3.06,0,0,0,2.54-1.12,3.82,3.82,0,0,0,.88,1,.35.35,0,0,0,.37,0l1.18-1a.28.28,0,0,0,0-.4h0A2.09,2.09,0,0,1,65,24.74V22.36c0-1,.07-1.94-.68-2.63A3.52,3.52,0,0,0,62,19c-1.47,0-3.1.54-3.45,2.35a.26.26,0,0,0,.2.31h0l1.48.15a.34.34,0,0,0,.29-.29,1.17,1.17,0,0,1,1.23-.91,1.11,1.11,0,0,1,.88.4,2.71,2.71,0,0,1,.19,1.32A10.62,10.62,0,0,0,59.91,22.82Zm2.61,2.67a1.24,1.24,0,0,1-1.07.69c-.59,0-.93-.43-.93-1.1,0-1.32,1.17-1.55,2.29-1.55v.33A3.16,3.16,0,0,1,62.52,25.49Z",
    transform: "translate(0)",
    style: {
      "fill": "#40f",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M45.35,26.17a2.13,2.13,0,0,1-.58-1.43V22.36c0-1,.07-1.94-.68-2.63A3.52,3.52,0,0,0,41.77,19c-1.46,0-3.1.54-3.44,2.35a.27.27,0,0,0,.22.31h0l1.47.15a.35.35,0,0,0,.3-.29,1.17,1.17,0,0,1,1.23-.91,1.08,1.08,0,0,1,.87.4,2.66,2.66,0,0,1,.19,1.31,11.41,11.41,0,0,0-2.9.53,2.62,2.62,0,0,0-1.64,2.51,2.17,2.17,0,0,0,2,2.38,1.45,1.45,0,0,0,.36,0,3.06,3.06,0,0,0,2.53-1.12,3.82,3.82,0,0,0,.88,1,.33.33,0,0,0,.36,0l1.19-1a.31.31,0,0,0,0-.42Zm-3-.68a1.22,1.22,0,0,1-1.07.69c-.59,0-.93-.43-.93-1.1,0-1.32,1.17-1.55,2.29-1.55v.33a3.06,3.06,0,0,1-.31,1.63Z",
    transform: "translate(0)",
    style: {
      "fill": "#40f",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M46.85,27.61h1.53a.3.3,0,0,0,.29-.29V23.15c0-.91,0-2.18,1.07-2.18s1,1.31,1,2.18v4.17a.29.29,0,0,0,.27.29h1.54a.3.3,0,0,0,.3-.28h0V23.15a4.75,4.75,0,0,1,.14-1.5,1,1,0,0,1,.92-.65.82.82,0,0,1,.91.68,12,12,0,0,1,0,1.47v4.17a.31.31,0,0,0,.28.29h1.53a.29.29,0,0,0,.3-.28h0v-5a4.1,4.1,0,0,0-.39-2.46,2.28,2.28,0,0,0-3.91.59,2.11,2.11,0,0,0-4,0h0v-1a.29.29,0,0,0-.29-.29H46.85a.29.29,0,0,0-.29.29h0v7.83a.3.3,0,0,0,.28.32Z",
    transform: "translate(0)",
    style: {
      "fill": "#40f",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M85.63,19a2.09,2.09,0,0,0-2.1,1.59h0v-1.2a.29.29,0,0,0-.29-.22H81.79a.29.29,0,0,0-.29.29h0v7.83a.3.3,0,0,0,.29.29h1.54a.29.29,0,0,0,.28-.29v-4.2a3.67,3.67,0,0,1,.25-1.5,1.07,1.07,0,0,1,.88-.62c.35,0,1,.05,1,1.64v4.75a.32.32,0,0,0,.27.25h1.55a.29.29,0,0,0,.29-.25V22.42a5,5,0,0,0-.4-2.44A2,2,0,0,0,85.63,19Z",
    transform: "translate(0)",
    style: {
      "fill": "#40f",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M101.53,19.33a5.38,5.38,0,0,0-3.17,1.14,2,2,0,0,0-2-1.14,5.34,5.34,0,0,0-3,1.05l-.1-.5a.39.39,0,0,0-.12-.25.54.54,0,0,0-.25-.06h-.68a.28.28,0,0,0-.32.23h0a.11.11,0,0,0,0,.08v7.45a.27.27,0,0,0,.23.31h1a.29.29,0,0,0,.32-.23V21.31a4.33,4.33,0,0,1,2.34-.7,1.17,1.17,0,0,1,1,.38,1.82,1.82,0,0,1,.3,1.18v5.17a.28.28,0,0,0,.24.31h1a.29.29,0,0,0,.33-.24v-6.1a4.54,4.54,0,0,1,2.35-.72,1.14,1.14,0,0,1,1,.38,1.89,1.89,0,0,1,.31,1.18v5.17a.28.28,0,0,0,.24.31.11.11,0,0,0,.08,0h.94a.27.27,0,0,0,.32-.21v0a.11.11,0,0,0,0-.08v-5.6a2.43,2.43,0,0,0-.59-1.75A2.22,2.22,0,0,0,101.53,19.33Z",
    transform: "translate(0)",
    style: {
      "fill": "#40f",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M112.68,19.57h-.94a.28.28,0,0,0-.32.23h0a.11.11,0,0,0,0,.08v6a4.21,4.21,0,0,1-2.33.77,1.34,1.34,0,0,1-1.07-.41,2,2,0,0,1-.34-1.27V19.89a.29.29,0,0,0-.23-.32h-1a.28.28,0,0,0-.32.23h0v5.64a2.49,2.49,0,0,0,.61,1.79,2.31,2.31,0,0,0,1.75.64,5.09,5.09,0,0,0,3.06-1.1l.11.56a.38.38,0,0,0,.13.24.5.5,0,0,0,.24.06h.69a.28.28,0,0,0,.32-.23h0a.11.11,0,0,0,0-.08V19.88a.28.28,0,0,0-.24-.31Z",
    transform: "translate(0)",
    style: {
      "fill": "#40f",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M118.9,23.25l-1.25-.48a3.4,3.4,0,0,1-1-.52.88.88,0,0,1-.26-.65c0-.7.52-1,1.54-1a5.82,5.82,0,0,1,1.76.26,1.55,1.55,0,0,0,.36.08c.14,0,.21-.1.21-.29v-.44a.48.48,0,0,0-.08-.31.59.59,0,0,0-.27-.17,6,6,0,0,0-2-.37,3.34,3.34,0,0,0-2.12.64,2.07,2.07,0,0,0-.81,1.68,2.33,2.33,0,0,0,1.78,2.23l1.32.51a3.12,3.12,0,0,1,.9.48.81.81,0,0,1,.25.62,1.08,1.08,0,0,1-.41.88,2,2,0,0,1-1.19.3,7.1,7.1,0,0,1-2.19-.34,1.37,1.37,0,0,0-.4-.09c-.13,0-.19.09-.19.29V27a.48.48,0,0,0,.07.31.59.59,0,0,0,.27.17,6,6,0,0,0,2.41.44,3.57,3.57,0,0,0,2.26-.63,2.19,2.19,0,0,0,.84-1.82,2,2,0,0,0-.44-1.31A3.3,3.3,0,0,0,118.9,23.25Z",
    transform: "translate(0)",
    style: {
      "fill": "#40f",
      "fillRule": "evenodd"
    }
  }), React.createElement("rect", {
    x: 122.36,
    y: 19.57,
    width: 1.58,
    height: 8.08,
    rx: 0.32,
    style: {
      "fill": "#40f"
    }
  }), React.createElement("path", {
    d: "M123.16,16.22a1,1,0,0,0-.73.27,1,1,0,0,0,0,1.38,1.15,1.15,0,0,0,1.46,0,1,1,0,0,0,0-1.38A1,1,0,0,0,123.16,16.22Z",
    transform: "translate(0)",
    style: {
      "fill": "#40f",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M131.79,26.27a.69.69,0,0,0-.24.05,5.4,5.4,0,0,1-1.44.22,2.41,2.41,0,0,1-1.89-.68,3.1,3.1,0,0,1-.61-2.12v-.21a3.2,3.2,0,0,1,.6-2.16,2.51,2.51,0,0,1,1.93-.68,4.9,4.9,0,0,1,1.32.19.75.75,0,0,0,.26.05c.13,0,.2-.1.2-.32v-.44a.52.52,0,0,0-.07-.32.5.5,0,0,0-.25-.15,4.92,4.92,0,0,0-1.7-.31A3.82,3.82,0,0,0,127,20.5a4.45,4.45,0,0,0-1,3.13,4.41,4.41,0,0,0,1,3.12,3.77,3.77,0,0,0,2.9,1.08,4.56,4.56,0,0,0,1.82-.34.56.56,0,0,0,.26-.17.5.5,0,0,0,0-.32v-.44C132,26.36,132,26.27,131.79,26.27Z",
    transform: "translate(0)",
    style: {
      "fill": "#40f",
      "fillRule": "evenodd"
    }
  }));
};

export default __webpack_public_path__ + "static/media/listen-amazon.510a4d7f.svg";
export { SvgComponent as ReactComponent };